.panel {
  display: flex;
  flex-direction: column;
  gap: var(--sp-6);
}

.muted {
  color: var(--text-3);
}

.hint {
  margin: 0;
  color: var(--text-3);
  font-size: var(--fs-sm);
}

.error {
  margin: 0;
  padding: var(--sp-4) var(--sp-5);
  border: var(--bw) solid var(--error-border);
  border-radius: var(--radius);
  background: var(--error-bg);
  color: var(--error);
  box-shadow: var(--glow-error);
  font-size: var(--fs-sm);
}

/* В строке сохранения ошибка стоит рядом с кнопкой — там ей хватает цвета,
   а рамка с подложкой ломала бы высоту строки. */
.saveBar .error {
  padding: 0;
  border: none;
  background: none;
  box-shadow: none;
}

.subtitle {
  margin: 0;
  font-size: var(--fs-md);
  font-weight: 600;
}

.block {
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
  padding: var(--sp-5);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius);
  background: var(--surface);
}

.switchRow {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
  font-weight: 500;
}

.providers {
  display: flex;
  flex-direction: column;
  gap: var(--sp-4);
  margin: var(--sp-2) 0 0;
  padding: 0;
  list-style: none;
}

.provider + .provider {
  padding-top: var(--sp-4);
  border-top: 1px solid var(--border);
}

/* Название источника и его готовность — в одной строке: галочка говорит про
   намерение, значок рядом — про то, работает ли источник на самом деле. */
.providerHead {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--sp-3);
}

.ready {
  color: var(--ok);
  font-size: var(--fs-sm);
}

.notReady {
  color: var(--warn);
  font-size: var(--fs-sm);
}

.tokenStatus {
  margin: 0;
  color: var(--text-2);
  font-size: var(--fs-sm);
}

.tokenRow {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
}

.tokenRow .input {
  flex: 1;
  min-width: 0;
}

/* Подпись кнопки в одну строку: рядом с широким полем она иначе ломается
   пополам и становится выше самого поля. */
.tokenRow button {
  white-space: nowrap;
}

.field {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.block .field {
  margin-top: var(--sp-4);
}

.advanced {
  padding-top: var(--sp-4);
  border-top: 1px solid var(--border);
}

.advancedBody {
  display: flex;
  flex-direction: column;
  gap: var(--sp-5);
  margin-top: var(--sp-4);
}

/* Числовому полю ширина всей панели не нужна: в нём одно-два знака, и растянутая
   на экран рамка читается как поле для текста. */
.advancedBody input {
  max-width: 220px;
}

.sanity {
  margin: 0;
  padding: 0;
  border: none;
}

.legend {
  padding: 0;
  font-size: var(--fs-sm);
  font-weight: 600;
}

.sanityGrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: var(--sp-4);
  margin-top: var(--sp-3);
}

.saveBar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--sp-4);
  padding-top: var(--sp-4);
  border-top: 1px solid var(--border);
}

.ok {
  color: var(--ok);
  font-size: var(--fs-sm);
}

/* Пустая область объявления не должна раздвигать строку сохранения. */
.ok:empty {
  display: none;
}

.updated {
  margin-left: auto;
  color: var(--text-3);
  font-size: var(--fs-xs);
}

/* Телефон: кнопка «Удалить» уезжает под поле — рядом с ним ей остаётся
   полсантиметра, и обе цели становятся неудобными. */
@media (max-width: 720px) {
  .tokenRow {
    flex-wrap: wrap;
  }

  .tokenRow .input {
    flex: 1 1 100%;
  }

  .updated {
    margin-left: 0;
    flex-basis: 100%;
  }
}
